<!-- 由 woniu6162 创建于 2021-10-21 星期四 -->
<template>
  <div class="p-cards">
    <template v-for="(item, index) in datum.slice(0, rank)">
      <div :key="`main${index}`" :class="['pc_top', fBg(item.rank)]">
        <div class="pc_t_left">
          <div class="pc_tl_ranks">
            <img :src="item.avatar" class="pc_tlr_user" />
            <img :src="fNumPic(item.rank)" class="pc_tlr_rank" />
            <img v-if="item.rank == 1" :src="crownPic" class="pc_tlr_crown" />
          </div>
          <div class="pc_tl_info">
            <div class="pc_tlf_name">{{ item.nickname }}</div>
            <div class="pc_tlf_fans">
              <span>{{ `粉丝 ${item.total_fans2}` }}</span>
              <span v-if="item.head_producer">{{
                ` 制作 ${item.head_producer}`
              }}</span>
            </div>
          </div>
        </div>
        <div class="pc_t_right">
          <img
            :src="fArrow(item.total_new_fans || item.total_new_play)"
            class="pc_tr_arrow"
          />
          <div>{{ fNew(item.total_new_fans2 || item.total_new_play2) }}</div>
        </div>
      </div>
    </template>
    <template v-for="(item, index) in datum.slice(rank)">
      <div :key="index" class="pc_item">
        <div class="pc_i_left">
          <div class="pc_il_rank">{{ item.rank }}</div>
          <div class="pc_il_info">
            <img :src="item.avatar" class="pc_ili_pic" />
            <div class="pc_ili_user">
              <div class="pc_iliu_name">{{ item.nickname }}</div>
              <div class="pc_iliu_fans">
                <span>{{ `粉丝 ${item.total_fans2}` }}</span>
                <span v-if="item.head_producer">{{
                  ` 制作 ${item.head_producer}`
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="pc_i_right">
          <img
            :src="fArrow(item.total_new_fans || item.total_new_play)"
            class="pc_ir_arrow"
          />
          <div>{{ fNew(item.total_new_fans2 || item.total_new_play2) }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'p-cards',

  mixins: [],

  components: {},

  props: {
    datum: {},
    rank: { type: Number, default: 3 }
  },

  data() {
    return {
      rank1: 'https://cdnvue.gymcity.com.cn/uploads/inner_rank1',
      rank2: 'https://cdnvue.gymcity.com.cn/uploads/inner_rank2',
      rank3: 'https://cdnvue.gymcity.com.cn/uploads/inner_rank3',
      crownPic: 'https://cdnvue.gymcity.com.cn/uploads/inner_rank_crown',
      upPic:
        'https://cdnvue.gymcity.com.cn/uploads/reducefat_midreport_uparrow',
      downPic:
        'https://cdnvue.gymcity.com.cn/uploads/reducefat_midreport_downarrow'
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    fNumPic(val) {
      let str
      switch (val) {
        case 1:
          str = this.rank1
          break
        case 2:
          str = this.rank2
          break
        case 3:
          str = this.rank3
          break
        default:
          break
      }
      return str
    },
    // 名次背景色
    fBg(val) {
      let str = ''
      switch (String(val)) {
        case '1':
          str = 'pc_top_one'
          break
        case '2':
          str = 'pc_top_two'
          break
        case '3':
          str = 'pc_top_three'
          break
        default:
          break
      }
      return str
    },
    // 增降箭头
    fArrow(val) {
      let str = this.upPic
      if (val < 0) str = this.downPic
      return str
    },
    // 取数值
    fNew(val) {
      let str = val
      if (!isNaN(val)) str = Math.abs(val)
      return str
    }
  }
}
</script>

<style lang="scss" scoped>
.p-cards {
  .pc_top {
    margin: 4.2vw auto 0;
    text-align: left;
    width: 91.5vw;
    padding: 3vw 2.4vw;
    border-radius: 1.1vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .pc_t_left {
      display: flex;
      align-items: center;
      .pc_tl_ranks {
        margin-left: 7.7vw;
        width: 11.5vw;
        height: 11.5vw;
        background-color: #d8d8d8;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 0;
        .pc_tlr_rank {
          height: 6.9vw;
          object-fit: cover;
          position: absolute;
          z-index: -1;
          left: -7.5vw;
        }
        .pc_tlr_user {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          border: solid 0.7vw #fff;
          box-sizing: border-box;
        }
        .pc_tlr_crown {
          width: 7vw;
          object-fit: cover;
          transform: rotate(34deg);
          position: absolute;
          top: -3.2vw;
          right: -1.5vw;
        }
      }
      .pc_tl_info {
        margin-left: 2.7vw;
        .pc_tlf_name {
          width: 40vw;
          font-size: 4.3vw;
          font-weight: 600;
          color: #000;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .pc_tlf_fans {
          margin-top: 0.5vw;
          max-width: 43vw;
          font-size: 3.2vw;
          color: #7f7f7f;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
      }
    }
    .pc_t_right {
      display: flex;
      align-items: center;
      font-size: 4.3vw;
      font-weight: 600;
      color: #ff5c5c;
      .pc_tr_arrow {
        margin-right: 1.1vw;
        height: 3.5vw;
        object-fit: cover;
      }
    }
  }
  .pc_top_one {
    background-image: linear-gradient(180deg, #fffaed 0%, #fff 100%);
    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: -1;
      top: -0.8vw;
      left: -0.8vw;
      right: -0.8vw;
      bottom: -0.8vw;
      border-radius: 1.1vw;
      background: linear-gradient(180deg, #fce395 0%, #fff 100%);
    }
  }
  .pc_top_two {
    background-image: linear-gradient(180deg, #fff 0%, #fff 100%);
    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: -1;
      top: -0.8vw;
      left: -0.8vw;
      right: -0.8vw;
      bottom: -0.8vw;
      border-radius: 1.1vw;
      background: linear-gradient(180deg, #dcdbdb 0%, #fff 100%);
    }
  }
  .pc_top_three {
    background-image: linear-gradient(180deg, #fff 0%, #fff 100%);
    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: -1;
      top: -0.8vw;
      left: -0.8vw;
      right: -0.8vw;
      bottom: -0.8vw;
      border-radius: 1.1vw;
      background: linear-gradient(180deg, #ffdec4 0%, #fff 100%);
    }
  }
  .pc_item {
    margin: 0 auto;
    text-align: left;
    width: 91.5vw;
    padding: 4vw 2.1vw 4vw 3.5vw;
    border-radius: 1.1vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: -4vw;
      width: 84vw;
      border-bottom: solid 0.3vw #f1f1f1;
    }
    .pc_i_left {
      display: flex;
      align-items: center;
      .pc_il_rank {
        width: 5vw;
        font-size: 4vw;
        color: rgba(0, 0, 0, 0.5);
      }
      .pc_il_info {
        margin-left: 2.4vw;
        display: flex;
        align-items: center;
        .pc_ili_pic {
          width: 11.5vw;
          height: 11.5vw;
          object-fit: cover;
          background-color: #e9e9e9;
          border-radius: 50%;
          border: solid 0.7vw #fff;
          box-sizing: border-box;
        }
        .pc_ili_user {
          margin-left: 2.4vw;
          .pc_iliu_name {
            font-size: 4.3vw;
            font-weight: 600;
            color: #000;
            width: 40vw;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          .pc_iliu_fans {
            margin-top: 0.5vw;
            max-width: 43vw;
            font-size: 3.2vw;
            color: #7f7f7f;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
        }
      }
    }
    .pc_i_right {
      display: flex;
      align-items: center;
      font-size: 4.3vw;
      font-weight: 600;
      color: #000;
      .pc_ir_arrow {
        margin-right: 1.1vw;
        height: 3.5vw;
        object-fit: cover;
      }
    }
  }
}
</style>
